import { KEEN_TABLE_VALUE, KEEN_TABLE_ANALYSIS } from './constants';
export var tableChartTransformation = function (query, value) {
    var _a;
    var analysis_type = query.analysis_type, event_collection = query.event_collection;
    return {
        data: [
            (_a = {},
                _a[KEEN_TABLE_ANALYSIS] = analysis_type + "." + event_collection,
                _a[KEEN_TABLE_VALUE] = value,
                _a),
        ],
        keys: [KEEN_TABLE_VALUE],
    };
};
